<template>
  <!-- <div id="app"> -->
    <router-view/>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
.isOLD{
  font-size: 18px !important;

  .el-input .el-input__inner {
    font-size: 18px !important;
  }

  .totalMenu .headChild{
    font-size: 22px !important;
    padding: 12px 6px !important;
  }
  .homeTop .headChild{
    font-size: 22px !important;
  }
  .inplace{
    font-size: 18px !important;
  }
  .allsearch{
    font-size: 18px !important;
  }
  .allsearch .searchButton span{
    font-size: 18px !important;
  }
  .el-table{
    font-size: 18px !important;
  }
  .el-table__row td{
    font-size: 18px !important;
  }
  .el-pagination{
    font-size: 18px !important;
    span, button {
      font-size: 18px !important;
    }
    .el-pager li{
      font-size: 18px !important;
    }
    .el-input .el-input__inner {
      font-size: 18px !important;
    }
  }
  .el-button--small{
    font-size: 16px;
    font-weight: bold;
  }
  .buttomTips{
    font-size: 18px !important;
  }
  .concent{
    font-size: 22px !important;
  }
  .pqname, .phname{
    font-size: 22px !important;
  }
  .fjName{
    font-size: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue